<template>
    <div>
        <!-- insert organization config form -->
        <div class="p-col-12 p-md-11 p-mx-auto p-mt-2">
            <div class="p-text-right">
                <Button
                    label="Add New Config"
                    @click="isNewConfigFormVisible = !isNewConfigFormVisible"
                    class="p-button-sm p-button-text p-button-outlined p-button-info p-text-right" /> 
            </div>
        </div>

        <transition name="expand">
        <div v-show="isNewConfigFormVisible" class="p-grid p-jc-center p-p-4">
            <div class="card p-col-12 p-md-11 p-mx-auto p-p-4">
                <div class="p-grid">
                    <div class="p-col-12 p-md-6">
                        <span class="p-float-label">
                            <InputText class="p-col-12" id="name" type="text" v-model="newConfigForm.name" />
                            <label for="name">Name</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <span class="p-float-label">
                            <InputText class="p-col-12" id="ss_unique_tournament_id" v-model="newConfigForm.ss_unique_tournament_id" />
                            <label for="ss_unique_tournament_id">SS Unique Tournament ID</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <div class="p-grid">
                            <div class="p-col-6 p-md-2">
                                <p>Tournament</p>
                                <InputSwitch v-model="newConfigForm.is_tournament" />
                            </div>
                            <div class="p-col-6 p-md-2">
                                <p>Media</p>
                                <InputSwitch v-model="newConfigForm.media_enabled" />
                            </div>
                            <div class="p-col-6 p-md-2">
                                <p>Commentary</p>
                                <InputSwitch v-model="newConfigForm.commentary_enabled" />
                            </div>
                            <div class="p-col-6 p-md-2">
                                <p>Playoff</p>
                                <InputSwitch v-model="newConfigForm.playoff_enabled" />
                            </div>
                            <div class="p-col-6 p-md-2">
                                <p>Standings</p>
                                <InputSwitch v-model="newConfigForm.standings_enabled" />
                            </div>
                            <div class="p-col-6 p-md-2">
                                <p>Round Manag.</p>
                                <InputSwitch v-model="newConfigForm.round_management_enabled" />
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6 p-pt-4">
                        <span class="p-float-label">
                            <Textarea class="p-col-12" id="comment" type="text" rows="2" :autoResize="true" v-model="newConfigForm.comment" />
                            <label for="comment">Comment</label>
                        </span>
                    </div>
                </div>
                <div class="p-grid p-jc-end p-m-0 p-pt-2">
                    <Button @click="addConfig()" label="Insert Organization Config" class="p-button p-button-info" />
                </div>
            </div>
        </div>
        </transition>

        <ProgressBar mode="indeterminate" v-show="isItemListLoading" style="height: .2em" />

        <!-- config datatable -->
        <div class="p-grid">
            <div class="p-col-12 p-md-11 p-mx-auto p-mt-2">
                <DataTable v-show="configList !== null && configList.length > 0" :paginator="true" :rows="25" :rowHover="true"
                    :value="configList" editMode="row" dataKey="id" v-model:filters="filters" filterDisplay="menu"
                    v-model:editingRows="editingRows" @row-edit-save="onRowEditSave" responsiveLayout="scroll"
                    :globalFilterFields="['name', 'comment']" >
                    <Column field="name" header="Name" sortable style="width:10%">
                        <template #body="{data}">
                            {{data.name}}
                        </template>
                        <template #editor="{data, field}">
                            <InputText v-model="data[field]" placeholder="Name" class="p-col-12" id="name" type="text" />
                        </template>
                    </Column>
                    <Column header="Sofa Score" style="width:10%">
                        <template #body="{data}" >
                            <div class="p-text-left">
                                <p>SS Id: <b>{{data.ss_unique_tournament_id}}</b></p>
                            </div>
                            <div class="p-text-left" v-if="data.ss_season_id !== undefined && data.ss_season_id !== null">
                                <p>Season Id: <b>{{data.ss_season_id}}</b></p>
                            </div>
                            <div class="p-text-left" v-else>
                                <Button label="Season not set" class="p-button-sm p-button-text p-button-plain" :disabled="true" />
                            </div>
                        </template>
                        <template #editor="{data, index}">
                            <div class="p-text-left">
                                <div class="p-text-left">
                                    <p>SS Id: <b>{{data.ss_unique_tournament_id}}</b></p>
                                </div>
                            </div>
                            <div class="p-text-center">
                                <Button :label="'Season Id ('+((data.ss_season_id !== undefined && data.ss_season_id !== null) ? data.ss_season_id : 'Not set')+')'"
                                    class="p-col-12 p-button-sm p-button-outlined p-button-info"
                                    @click="showSSSeasonUpdateModal(data, index, data.ss_unique_tournament_id, data.ss_season_id)" />
                            </div>
                            <div class="p-text-center p-mt-4">
                                <Button label="Update Teams" class="p-button-sm p-button-info p-button-text"
                                    @click="ssUpdateTeams(data.ss_unique_tournament_id)"
                                    :loading="isSSTeamUpdating" />
                            </div>
                        </template>
                    </Column>
                    <Column header="One Football" style="width:10%">
                        <template #body="{data}" >
                            <div class="p-text-left" v-show="data.of_id !== undefined && data.of_id !== null">
                                <p>OF Id: <b>{{data.of_id}}</b></p>
                            </div>
                            <div class="p-text-left" v-show="data.of_season_id !== undefined && data.of_season_id !== null">
                                <p>Season Id: <b>{{data.of_season_id}}</b></p>
                            </div>
                            <div class="p-text-center">
                                <Button label="Not available"
                                    v-show="data.of_id === undefined || data.of_id === null"
                                    class="p-button-sm p-button-outlined p-button-plain"
                                    :disabled="true" />
                            </div>
                        </template>
                        <template #editor="{data, index}">
                            <div class="p-text-left" v-show="data.of_id !== undefined && data.of_id !== null">
                                <p>OF Id: <b>{{data.of_id}}</b></p>
                            </div>
                            <div class="p-text-left" v-show="data.of_season_id !== undefined && data.of_season_id !== null">
                                <p>Season Id: <b>{{data.of_season_id}}</b></p>
                            </div>
                            <div class="p-text-left p-mt-3">
                                <Button :label="((data.of_season_id !== undefined && data.of_season_id !== null) ? data.of_id +' : '+ data.of_season_id : '(Config not set)')"
                                    class="p-col-12 p-button-sm p-button-outlined p-button-info"
                                    @click="showOFConfigUpdateModal(data, index, data.of_id, data.of_season_id)" />
                            </div>
                        </template>
                    </Column>
                    <Column header="Options" style="width:15%">
                        <template #body="{data}">
                            <div class="p-grid">
                                <div class="p-col-12">
                                    <Checkbox id="is_tournament" class="p-mr-3"
                                        v-model="data.is_tournament" :binary="true" :disabled="true" />
                                    <label for="is_tournament">Tournament</label>
                                </div>
                                <div class="p-col-12">
                                    <Checkbox id="media_enabled" class="p-mr-3"
                                        v-model="data.media_enabled" :binary="true" :disabled="true" />
                                    <label for="media_enabled">Media</label>
                                </div>
                                <div class="p-col-12">
                                    <Checkbox id="commentary_enabled" class="p-mr-3"
                                        v-model="data.commentary_enabled" :binary="true" :disabled="true" />
                                    <label for="commentary_enabled">Commentary</label>
                                </div>
                                <div class="p-col-12">
                                    <Checkbox id="playoff_enabled" class="p-mr-3"
                                        v-model="data.playoff_enabled" :binary="true" :disabled="true" />
                                    <label for="playoff_enabled">Playoff</label>
                                </div>
                                <div class="p-col-12">
                                    <Checkbox id="standings_enabled" class="p-mr-3"
                                        v-model="data.standings_enabled" :binary="true" :disabled="true" />
                                    <label for="standings_enabled">Standings</label>
                                </div>
                                <div class="p-col-12">
                                    <Checkbox id="round_management_enabled" class="p-mr-3"
                                        v-model="data.round_management_enabled" :binary="true" :disabled="true" />
                                    <label for="round_management_enabled">Round Management</label>
                                </div>
                            </div>
                        </template>
                        <template #editor="{data}">
                            <div class="p-grid">
                                <div class="p-col-12">
                                    <Checkbox id="is_tournament" class="p-mr-3"
                                        v-model="data.is_tournament" :binary="true" :disabled="false" />
                                    <label for="is_tournament">Tournament</label>
                                </div>
                                <div class="p-col-12">
                                    <Checkbox id="media_enabled" class="p-mr-3"
                                        v-model="data.media_enabled" :binary="true" :disabled="false" />
                                    <label for="media_enabled">Media</label>
                                </div>
                                <div class="p-col-12">
                                    <Checkbox id="commentary_enabled" class="p-mr-3"
                                        v-model="data.commentary_enabled" :binary="true" :disabled="false" />
                                    <label for="commentary_enabled">Commentary</label>
                                </div>
                                <div class="p-col-12">
                                    <Checkbox id="playoff_enabled" class="p-mr-3"
                                        v-model="data.playoff_enabled" :binary="true" :disabled="false" />
                                    <label for="playoff_enabled">Playoff</label>
                                </div>
                                <div class="p-col-12">
                                    <Checkbox id="standings_enabled" class="p-mr-3"
                                        v-model="data.standings_enabled" :binary="true" :disabled="false" />
                                    <label for="standings_enabled">Standings</label>
                                </div>
                                <div class="p-col-12">
                                    <Checkbox id="round_management_enabled" class="p-mr-3"
                                        v-model="data.round_management_enabled" :binary="true" :disabled="false" />
                                    <label for="round_management_enabled">Round Management</label>
                                </div>
                            </div>
                        </template>
                    </Column>
                    <Column field="current_round" header="Current Round" style="width:15%">
                        <template #body="{data}">
                            <div v-if="data.round_management_enabled && data.current_round !== undefined && data.current_round !== null">
                                <span
                                    v-if="data.current_round.round !== undefined && data.current_round.round !== null && data.current_round.round > 0">
                                    <label for="current_round" class="p-text-light">Current Round: </label>
                                    <label class="p-text-bold">{{data.current_round.round}}</label>
                                </span>
                                <span
                                    v-if="data.current_round.slug !== undefined && data.current_round.slug !== null && data.current_round.slug.length > 0">
                                    <br/>
                                    <label for="slug" class="p-text-light">Slug: </label>
                                    <label class="p-text-bold">{{data.current_round.slug}}</label>
                                </span>
                                <span 
                                    v-if="data.current_round.name !== undefined && data.current_round.name !== null && data.current_round.name.length > 0">
                                    <br/>
                                    <label for="name" class="p-text-light">Name: </label>
                                    <label class="p-text-bold">{{data.current_round.name}}</label>
                                </span>
                                <span 
                                    v-if="data.current_round.prefix !== undefined && data.current_round.prefix !== null && data.current_round.prefix.length > 0">
                                    <br/>
                                    <label for="prefix" class="p-text-light">Prefix: </label>
                                    <label class="p-text-bold">{{data.current_round.prefix}}</label>
                                </span>
                            </div>
                            <div v-if="!data.round_management_enabled">
                                <Button label="Not available" class="p-button-sm p-button-text p-button-plain" :disabled="true" />
                            </div>
                        </template>
                        <template #editor="{data, index}">
                            <div v-if="data.round_management_enabled" class="p-text-center">
                                <span
                                    v-if="data.current_round !== undefined && data.current_round !== null
                                        && data.current_round.round !== undefined && data.current_round.round !== null && data.current_round.round > 0">
                                    <label for="current_round" class="p-text-light">Current Round: </label>
                                    <label class="p-text-bold">{{data.current_round.round}}</label>
                                </span>
                                <Button label="Select Round" class="p-button-sm p-button-info p-button-text p-mt-2"
                                    v-if="data.ss_unique_tournament_id !== undefined && data.ss_unique_tournament_id !== null && data.ss_unique_tournament_id > 0
                                        && data.ss_season_id !== undefined && data.ss_season_id !== null && data.ss_season_id > 0"
                                    @click="ssUpdateCurrentRound(data, index, data.ss_unique_tournament_id, data.ss_season_id)" />
                            </div>
                            <div v-else>
                                <Button label="Not available" class="p-button-sm p-button-text p-button-plain" :disabled="true" />
                            </div>
                        </template>
                    </Column>
                    <Column field="comment" header="Comment" style="width:15%">
                        <template #body="{data}">
                            <div v-html="getFormattedComment(data.comment)"></div>
                        </template>
                        <template #editor="{data, field}">
                            <Textarea v-model="data[field]" rows="2" :autoResize="true"
                                placeholder="Comment" class="p-col-12" id="comment" />
                        </template>
                    </Column>
                    <Column field="last_updated_date" header="Last Update" sortable dataType="date" class="p-text-center" style="width:10%; line-height: 1.25rem;">
                        <template #body="{data}">
                            <div v-html="getFormattedDate(data.last_updated_date)" style="width:100%"></div>
                        </template>
                        <template #editor="{}"></template>
                    </Column>
                    <Column :rowEditor="true" style="width:10%" bodyStyle="text-align:right;"></Column>
                    <Column header="" style="width:5%" bodyStyle="text-align:left;">
                        <template #body="item">
                        <div style="">
                            <Button label="" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-plain"
                            @click="deleteConfig(item.data.id)" />
                        </div>
                        </template>
                        <template #editor="{}"></template>
                    </Column>
                </DataTable>
            </div>
        </div>

        <!-- ss season update config modal dialog -->
        <Dialog v-model:visible="ssSeasonUpdateModal.visible"
            :header="ssSeasonUpdateModal.title" :modal="true" class="p-fluid p-col-6 p-text-center">
            <ProgressSpinner style="width:40px; height:40px" class="p-m-4"
                strokeWidth="4" fill="var(--surface-ground)" animationDuration="1.5s"
                v-show="ssSeasonUpdateModal.loading" />

            <DataTable v-show="!ssSeasonUpdateModal.loading" :value="ssSeasonUpdateModal.items" dataKey="id" responsiveLayout="scroll">
                <Column field="id" header="Season Id" style="width:25%"></Column>
                <Column field="year" header="Year" style="width:20%"></Column>
                <Column field="name" header="Name" style="width:35%"></Column>
                <Column header="Select" style="width:20%">
                    <template #body="item">
                        <Button class="p-button-outlined p-button-rounded p-button-info"
                            @click="ssSeasonSelected(item.data.id)"
                            icon="pi pi-check"
                            v-show="item.data.id !== ssSeasonUpdateModal.currentSeasonId" />
                        
                        <p v-show="item.data.id === ssSeasonUpdateModal.currentSeasonId">
                            Current
                        </p>
                    </template>
                </Column>
            </DataTable>
        </Dialog>

        <!-- of config update modal dialog -->
        <Dialog v-model:visible="ofConfigUpdateModal.visible"
            :header="ofConfigUpdateModal.title" :modal="true" class="p-fluid p-col-6 p-text-center">
        
            <ProgressSpinner style="width:40px; height:40px" class="p-m-4"
                strokeWidth="4" fill="var(--surface-ground)" animationDuration="1.5s"
                v-show="ofConfigUpdateModal.loading" />

            <DataTable v-show="!ofConfigUpdateModal.loading" :value="ofConfigUpdateModal.items" dataKey="competitionId" responsiveLayout="scroll">
                <Column field="competitionId" header="Competition Id" style="width:25%"></Column>
                <Column field="section" header="Section" sortable style="width:5%"></Column>
                <Column field="competitionName" header="Name" sortable style="width:30%"></Column>
                <Column field="seasonId" header="Season Id" style="width:15%"></Column>
                <Column header="Select" style="width:20%">
                    <template #body="item">
                        <Button class="p-button-outlined p-button-rounded p-button-info"
                            @click="ofConfigSelected(item.data.competitionId, item.data.seasonId)"
                            icon="pi pi-check"
                            v-show="item.data.competitionId !== ofConfigUpdateModal.currentOfId && item.data.seasonId !== ofConfigUpdateModal.currentOfSeasonId" />
                        
                        <p v-show="item.data.competitionId === ofConfigUpdateModal.currentOfId && item.data.seasonId === ofConfigUpdateModal.currentOfSeasonId">
                            Current
                        </p>
                    </template>
                </Column>
            </DataTable>
        </Dialog>

        <!-- ss season current round update modal dialog -->
        <Dialog v-model:visible="ssCurrentRoundUpdateModal.visible"
            :header="ssCurrentRoundUpdateModal.title" :modal="true" class="p-fluid p-col-6 p-text-center">
            <ProgressSpinner style="width:40px; height:40px" class="p-m-4"
                strokeWidth="4" fill="var(--surface-ground)" animationDuration="1.5s"
                v-show="ssCurrentRoundUpdateModal.loading" />

            <DataTable v-show="!ssCurrentRoundUpdateModal.loading" :value="ssCurrentRoundUpdateModal.items" dataKey="id" responsiveLayout="scroll">
                <Column header="Select" style="width:15%">
                    <template #body="item">
                        <Button class="p-button-outlined p-button-rounded p-button-info"
                            @click="ssRoundSelected(item.data)"
                            icon="pi pi-check"
                            v-show="(ssCurrentRoundUpdateModal.currentRound === undefined || ssCurrentRoundUpdateModal.currentRound === null)
                                || ssCurrentRoundUpdateModal.currentRound.round !== item.data.round
                                || ssCurrentRoundUpdateModal.currentRound.slug !== item.data.slug
                                || ssCurrentRoundUpdateModal.currentRound.prefix !== item.data.prefix" />
                        
                        <p v-if="ssCurrentRoundUpdateModal.currentRound !== undefined && ssCurrentRoundUpdateModal.currentRound !== null
                            && ssCurrentRoundUpdateModal.currentRound.round === item.data.round
                            && (ssCurrentRoundUpdateModal.currentRound.slug === item.data.slug
                                && ssCurrentRoundUpdateModal.currentRound.prefix === item.data.prefix)">
                            Current
                        </p>
                    </template>
                </Column>
                <Column field="round" header="Round" style="width:15%"></Column>
                <Column field="name" header="Name" style="width:15%"></Column>
                <Column field="slug" header="Slug" style="width:15%"></Column>
                <Column field="prefix" header="Prefix" style="width:15%"></Column>
                <Column header="SS Current" class="p-text-center" style="width:25%">
                    <template #body="item">
                        <p v-if="ssCurrentRoundUpdateModal.ssCurrentRound !== undefined && ssCurrentRoundUpdateModal.ssCurrentRound !== null
                            && ssCurrentRoundUpdateModal.ssCurrentRound.round === item.data.round
                            && (ssCurrentRoundUpdateModal.ssCurrentRound.slug === item.data.slug
                                && ssCurrentRoundUpdateModal.ssCurrentRound.prefix === item.data.prefix)">
                            SS Current Round
                        </p>
                    </template>
                </Column>
            </DataTable>
        </Dialog>
    </div>

    <Divider align="center" class="p-mt-6">
        <div class="p-d-inline-flex p-ai-center">
        <b>About</b>
        </div>
    </Divider>

    <div class="p-col-12 p-md-9 p-mx-auto p-mt-2 p-text-left">
        <div class="p-d-flex">
        <i class="fa fa-info p-mr-3"></i> Uygulama genelindeki organizasyonların/turnuvaların yönetimi bu modülden yapılır.
        <br/> Round Management seçili olan turnuvalar için;
        <br/> - jobUpdateCurrentRounds cronjob'ı çalışarak Current Round (güncel hafta) bilgisini kaydeder.
        <br/> - jobUpdateCurrentRoundEvents cronjob'ı çalışarak güncel fikstür bilgisini kaydeder.
        <br/> Organizasyonlarda Current Round seçilebilmesi için Round Management seçili olmalıdır.
        </div>
    </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'
import InputSwitch from 'primevue/inputswitch'
import ProgressBar from 'primevue/progressbar'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Checkbox from 'primevue/checkbox'
import Dialog from 'primevue/dialog'
import ProgressSpinner from 'primevue/progressspinner'
import Divider from 'primevue/divider'

import Const from '../utils/const'
import { isEmpty } from '../utils/utils'
import moment from 'moment'

export default {
    name: 'ConfigOrganization',
    emits: ["loginResult", "pageLoaded"],
    components: {
        InputText, InputSwitch, Textarea, Button, ProgressBar, DataTable, Column, Checkbox, Dialog,
        ProgressSpinner, Divider
    },
    data() {
        return {
            isNewConfigFormVisible: false,
            newConfigForm: {},
            isItemListLoading: false,
            configList: [],
            editingRows: [],
            filters: {
                'name': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'comment': {value: null, matchMode: FilterMatchMode.CONTAINS}
            },
            ssSeasonUpdateModal: {
                title: 'Season Update',
                visible: false,
                loading: false,
                items: [],
                currentSeasonId: -1,
                selectedOrganizationIndex: -1,
                currentConfigRowData: null
            },
            ssCurrentRoundUpdateModal: {
                title: 'Select Current Round',
                visible: false,
                loading: false,
                items: [],
                currentRound: {},
                selectedOrganizationIndex: -1,
                currentConfigRowData: null,
                ssCurrentRound: {}
            },
            ofConfigUpdateModal: {
                title: 'Config Update',
                visible: false,
                loading: false,
                items: [],
                currentOfId: -1,
                currentOfSeasonId: -1,
                selectedOrganizationIndex: -1,
                currentConfigRowData: null
            },
            isSSTeamUpdating: false
        }
    },
    beforeMount() {
        var page = {
            title: "Organization Config"
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.loadConfig()
    },
    methods: {
        loadConfig() {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token');

            self.isItemListLoading = true
            self.$http.get('api/config/organization', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.isItemListLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.configList = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading organization config failed', detail:response.data.mesaj, life: 3000});
                }
            }).catch(function (err) {
                self.isItemListLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        showSSSeasonUpdateModal(rowData, index, ssUniqueTournamentId, ssSeasonId) {
            let self = this,
                ssSeasonUpdateModal = self.ssSeasonUpdateModal,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
                
            // show and start loading
            ssSeasonUpdateModal.visible = true
            ssSeasonUpdateModal.currentSeasonId = ssSeasonId
            ssSeasonUpdateModal.selectedOrganizationIndex = index
            ssSeasonUpdateModal.currentConfigRowData = rowData

            ssSeasonUpdateModal.loading = true
            self.$http.get('api/tournaments/source/ss/'+ssUniqueTournamentId+'/seasons', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                ssSeasonUpdateModal.loading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    ssSeasonUpdateModal.items = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    console.log(response.data)
                    toast.add({severity:'warn', summary: 'Get seasons from SS service failed! Check console.', detail: response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                ssSeasonUpdateModal.loading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        ssSeasonSelected(newSeasonId) {
            let self = this,
                ssSeasonUpdateModal = self.ssSeasonUpdateModal,
                index = ssSeasonUpdateModal.selectedOrganizationIndex
                
            self.configList[index].ss_season_id = newSeasonId
            ssSeasonUpdateModal.currentConfigRowData.ss_season_id = newSeasonId

            ssSeasonUpdateModal.visible = false
        },
        showOFConfigUpdateModal(rowData, index, ofId, ofSeasonId) {
            let self = this,
                ofConfigUpdateModal = self.ofConfigUpdateModal,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
                
            // show and start loading
            ofConfigUpdateModal.visible = true
            ofConfigUpdateModal.currentOfId = ofId
            ofConfigUpdateModal.currentOfSeasonId = ofSeasonId
            ofConfigUpdateModal.selectedOrganizationIndex = index
            ofConfigUpdateModal.currentConfigRowData = rowData

            ofConfigUpdateModal.loading = true
            self.$http.get('api/tournaments/source/of/config', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                ofConfigUpdateModal.loading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    ofConfigUpdateModal.items = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    console.log(response.data)
                    toast.add({severity:'warn', summary: 'Get config from OF service failed! Check console.', detail: response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                ofConfigUpdateModal.loading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        ofConfigSelected(competitionId, seasonId) {
            let self = this,
                ofConfigUpdateModal = self.ofConfigUpdateModal,
                index = ofConfigUpdateModal.selectedOrganizationIndex
            
            self.configList[index].of_id = competitionId
            self.configList[index].of_season_id = seasonId
            ofConfigUpdateModal.currentConfigRowData.of_id = competitionId
            ofConfigUpdateModal.currentConfigRowData.of_season_id = seasonId

            ofConfigUpdateModal.visible = false
        },
        addConfig() {
            let self = this,
                toast = self.$toast,
                newConfigForm = self.newConfigForm,
                toastMessage = null,
                cookies = self.$cookies,
                token = self.$cookies.get('token');

            if(isEmpty(newConfigForm.name)) {
                toastMessage = 'Name is empty!'
            } else if(isEmpty(newConfigForm.ss_unique_tournament_id)) {
                toastMessage = 'SS ID is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            self.$http.post('api/config/organization', newConfigForm, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    let newAddedItem = response.data.item
                    
                    self.configList.push(newAddedItem)

                    toast.add({severity:'success', summary: 'Success', detail: 'Organization config added successfully.', life: 3000});

                    self.newConfigForm = {}
                } else {
                    console.log(response)
                    toast.add({severity:'warn', summary: 'Organization config insert failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        onRowEditSave(event) {
            let { newData, index } = event;

            let self = this,
                configId = newData.id,
                newConfig = {
                    id: configId,
                    name: newData.name,
                    ss_unique_tournament_id: newData.ss_unique_tournament_id,
                    ss_season_id: newData.ss_season_id,
                    of_id: newData.of_id,
                    of_season_id: newData.of_season_id,
                    is_tournament: newData.is_tournament,
                    media_enabled: newData.media_enabled,
                    commentary_enabled: newData.commentary_enabled,
                    playoff_enabled: newData.playoff_enabled,
                    standings_enabled: newData.standings_enabled,
                    comment: newData.comment,
                    round_management_enabled: newData.round_management_enabled,
                    current_round: newData.current_round
                },
                toast = self.$toast,
                toastMessage = null,
                cookies = self.$cookies,
                token = cookies.get('token');
            
            if(isEmpty(newConfig.name)) {
                toastMessage = 'Name is empty!'
            } else if(isEmpty(newConfig.ss_unique_tournament_id)) {
                toastMessage = 'SS ID is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            self.$http.put('api/config/organization/'+configId, newData, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    
                    self.configList[index] = response.data.item;

                    toast.add({severity:'success', summary: 'Success', detail: 'Updated successfully.', life: 3000});
                } else {
                    toast.add({severity:'warn', summary: 'Update failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        deleteConfig(configId) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            this.$confirm.require({
                message: 'Are you sure you want to delete this organization config permanently?',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: () => {
                    self.$http.delete('api/config/organization/'+configId, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                    }).then(function (response) {
                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set("token", response.headers['refresh-token']);

                            self.loadConfig()

                            toast.add({severity:'success', summary: 'Success', detail: 'Organization config deleted successfully.', life: 3000});
                        } else {
                            console.log(response)
                            toast.add({severity:'warn', summary: 'Organization config delete failed', detail:response.data.mesaj, life: 3000});
                        }
                    }).catch(function (err) {
                        console.log(err)
                        toast.add({severity: 'error', summary: 'Error', detail: err});
                    });
                },
                reject: () => {
                }
            });
        },
        getFormattedDate(logDate) {
            return moment(new Date(logDate)).format('DD/MM/YYYY HH:mm');
        },
        getFormattedComment(comment) {
            return !isEmpty(comment) ? comment.replaceAll('\n', '<br/>') : null
        },
        ssUpdateTeams(ssUniqueTournamentId) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            self.isSSTeamUpdating = true
            self.$http.post('api/tournaments/source/ss/'+ssUniqueTournamentId+'/update-teams', null, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.isSSTeamUpdating = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);

                    toast.add({severity:'success', summary: 'Success', detail: 'Teams updated successfully.', life: 3000});
                } else {
                    console.log(response)
                    toast.add({severity:'warn', summary: 'Team update failed!', detail:response.data.mesaj, life: 3000});
                }
            }).catch(function (err) {
                self.isSSTeamUpdating = false
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        ssUpdateCurrentRound(rowData, index, ssUniqueTournamentId, ssSeasonId) {
            let self = this,
                ssCurrentRoundUpdateModal = self.ssCurrentRoundUpdateModal,
                toast = self.$toast,
                toastMessage = null,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            if(isEmpty(ssUniqueTournamentId)) {
                toastMessage = 'SS Unique Tournament ID is empty!'
            } else if(isEmpty(ssSeasonId)) {
                toastMessage = 'SS Season ID is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            // show and start loading
            ssCurrentRoundUpdateModal.visible = true
            ssCurrentRoundUpdateModal.currentRound = rowData.current_round
            ssCurrentRoundUpdateModal.selectedOrganizationIndex = index
            ssCurrentRoundUpdateModal.currentConfigRowData = rowData

            ssCurrentRoundUpdateModal.loading = true
            self.$http.get('api/tournaments/source/ss/'+ssUniqueTournamentId+'/season/'+ssSeasonId+'/rounds', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                ssCurrentRoundUpdateModal.loading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])
                    && response.data.items.rounds !== undefined && response.data.items.rounds !== null && response.data.items.rounds.length > 0) {
                    cookies.set('token', response.headers['refresh-token']);
                    ssCurrentRoundUpdateModal.items = response.data.items.rounds
                    ssCurrentRoundUpdateModal.ssCurrentRound = response.data.items.currentRound
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    console.log(response.data)
                    toast.add({severity:'warn', summary: 'Get rounds from SS service failed! Check console.', detail: response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                ssCurrentRoundUpdateModal.loading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        ssRoundSelected(round) {
            let self = this,
                ssCurrentRoundUpdateModal = self.ssCurrentRoundUpdateModal,
                index = ssCurrentRoundUpdateModal.selectedOrganizationIndex
                
            self.configList[index].current_round = round
            self.configList[index].round_management_enabled = true
            ssCurrentRoundUpdateModal.currentConfigRowData.current_round = round

            ssCurrentRoundUpdateModal.visible = false
        }
    }
}
</script>